<template>
	<v-container fluid class="pa-2">
		<!-- Topo -->
		<v-row dense>
			<v-col cols="12">
				<div class="d-flex align-center justify-space-between mb-2">
					<div class="d-flex align-center">
						<v-icon class="mr-2" small>mdi-cog</v-icon>
						<span class="text-subtitle-1 font-weight-medium">Configurações</span>
					</div>

					<v-chip small outlined class="px-2">
						<v-icon left small>mdi-shield-account</v-icon>
						{{ user?.tipo || 'Usuário' }}
					</v-chip>
				</div>
			</v-col>
		</v-row>

		<v-row dense>
			<v-col cols="12">
				<v-card outlined class="card-soft">
					<v-card-title class="py-2 px-3 d-flex align-center justify-space-between">
						<div class="d-flex align-center">
							<v-icon small class="mr-2">mdi-tune-variant</v-icon>
							<span class="text-subtitle-2 font-weight-medium">Sistema</span>
						</div>
						<span class="text-caption grey--text">Ative/desative recursos</span>
					</v-card-title>

					<v-divider />

					<v-card-text class="pa-3">
						<v-row dense>
							<v-col
							v-for="item in configuracoesFiltradas"
							:key="item.idativos"
							cols="12"
							sm="6"
							md="4"
							lg="3"
							>
							<v-sheet class="config-item px-3 py-2" outlined rounded>
								<div class="d-flex align-center justify-space-between">
									<div class="mr-2">
										<div class="text-caption font-weight-medium">
											{{ formatConfigName(item.nome) }}
										</div>
										<div class="text-caption grey--text">
											{{ item.estado ? 'Ativo' : 'Inativo' }}
										</div>
									</div>

									<v-switch
									v-model="item.estado"
									@change="saveConfig(item)"
									inset
									dense
									hide-details
									color="primary"
									/>
								</div>
							</v-sheet>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-col>
	</v-row>

	<v-row dense class="mt-2">
		<v-col cols="12">
			<v-card outlined class="card-soft">
				<v-card-title class="py-2 px-3 d-flex align-center justify-space-between">
					<div class="d-flex align-center">
						<v-icon small class="mr-2">mdi-account-group</v-icon>
						<span class="text-subtitle-2 font-weight-medium">Usuários</span>
					</div>

					<v-text-field
					v-model="search"
					append-icon="mdi-magnify"
					label="Buscar usuário"
					dense
					hide-details
					outlined
					class="search-input"
					/>
				</v-card-title>

				<v-divider />

				<v-data-table
				:headers="headers"
				:items="funcionariosFiltrados"
				:items-per-page="-1"
				:search="search"
				hide-default-footer
				dense
				class="compact-table"
				>
				<template v-slot:item.nome="{ item }">
					<div class="py-1">
						<div class="text-body-2 font-weight-medium">{{ item.nome }}</div>
						<div class="text-caption grey--text">{{ item.tipo }}</div>
					</div>
				</template>

				<template v-slot:item.status="{ item }">
					<v-switch
					v-model="item.status"
					@change="toggleAcesso(item)"
					:disabled="user.id === item.idusuarios"
					inset
					dense
					hide-details
					color="success"
					/>
				</template>

				<template v-slot:item.reconhecimento_facial="{ item }">
					<v-switch
					v-model="item.reconhecimento_facial"
					@change="toggleReconhecimentoFacial(item)"
					:disabled="!reconhecimentoFacialAtivo"
					inset
					dense
					hide-details
					color="primary"
					/>
				</template>

				<template v-slot:item.acesso_desktop="{ item }">
					<v-switch
					v-model="item.acesso_desktop"
					@change="toggleAcessoDesktop(item)"
					inset
					dense
					hide-details
					color="warning"
					/>
				</template>

				<template v-for="p in permissoes" v-slot:[`item.${p.value}`]="{ item }">
					<div :key="p.value" class="d-flex justify-center">
						<v-checkbox
						v-model="item.permissoes[p.key]"
						@change="updatePermissao(item, p.key)"
						:disabled="user.id === item.idusuarios"
						dense
						hide-details
						class="perm-check"
						color="primary"
						/>
					</div>
				</template>

				<template v-slot:item.perm_editar_ponto="{ item }">
					<div class="d-flex justify-center">
						<v-checkbox
						v-model="item.permissoes.editar_ponto"
						@change="updatePermissaoExtra(item, 'perm_editar_ponto', item.permissoes.editar_ponto)"
						:disabled="user.id === item.idusuarios"
						dense
						hide-details
						class="perm-check"
						color="primary"
						/>
					</div>
				</template>
			</v-data-table>
		</v-card>
	</v-col>
</v-row>
</v-container>
</template>

<script>
import axios from 'axios'
import { baseApiUrl, showError } from '@/global'
import { mapState } from 'vuex'

export default {
	name: 'TheConfiguracoes',
	data () {
		return {
			search: '',
			configuracoes: [],
			funcionarios: [],

			permissoes: [
				{ text: 'Ind', key: 'indicadores', value: 'perm_indicadores' },
				{ text: 'Col', key: 'colaboradores', value: 'perm_colaboradores' },
				{ text: 'Car', key: 'carga', value: 'perm_carga' },
				{ text: 'Ban', key: 'banco', value: 'perm_banco' },
				{ text: 'Age', key: 'agendamentos', value: 'perm_agendamentos' },
				{ text: 'Sol', key: 'solicitacoes', value: 'perm_solicitacoes' },
				{ text: 'Rel', key: 'relatorios', value: 'perm_relatorios' }
				]
		}
	},
	computed: {
		...mapState(['user']),
		reconhecimentoFacialAtivo () {
			const cfg = this.configuracoes.find(i => i.nome === 'reconhecimento_facial')
			return cfg ? !!cfg.estado : false
		},
		configuracoesFiltradas () {
			return this.configuracoes.filter(i => i.nome !== 'acesso_externo')
		},
		headers () {
			return [
				{ text: 'Usuário', value: 'nome', sortable: true, width: '240px' },
				{ text: 'Ativo', value: 'status', align: 'center', sortable: false, width: '72px' },
				{ text: 'Face', value: 'reconhecimento_facial', align: 'center', sortable: false, width: '72px' },
				{ text: 'Ext', value: 'acesso_desktop', align: 'center', sortable: false, width: '72px' },
				...this.permissoes.map(p => ({ text: p.text, value: p.value, align: 'center', sortable: false, width: '56px' })),
				{ text: 'Pto', value: 'perm_editar_ponto', align: 'center', sortable: false, width: '56px' }
				]
		},
		funcionariosFiltrados () {
			if (!this.user) 
				return this.funcionarios
			if (this.user.tipo === 'Gerente') {
				return this.funcionarios.filter(u => u.tipo !== 'Admin')
			}
			return this.funcionarios
		}
	},

	methods: {
		async loadConfig () {
			try {
				const res = await axios.get(`${baseApiUrl}/ativos`)
				this.configuracoes = res.data
			} catch (e) {
				showError(e)
			}
		},

		async loadFuncionarios () {
			try {
				const res = await axios.get(`${baseApiUrl}/usuarios?status=todos`)
				const lista = res.data || []
				this.funcionarios = lista.map(u => this.normalizeUsuario(u))
			} catch (e) {
				showError(e)
			}
		},

		normalizeUsuario (u) {
			const toBool = (v) => v === 1 || v === true || v === '1'

			return {
				...u,
				status: toBool(u.status),
				reconhecimento_facial: toBool(u.reconhecimento_facial),
				acesso_desktop: toBool(u.acesso_desktop),

				permissoes: {
					indicadores: toBool(u.perm_indicadores),
					colaboradores: toBool(u.perm_colaboradores),
					carga: toBool(u.perm_carga),
					banco: toBool(u.perm_banco),
					agendamentos: toBool(u.perm_agendamentos),
					solicitacoes: toBool(u.perm_solicitacoes),
					relatorios: toBool(u.perm_relatorios),
					editar_ponto: toBool(u.perm_editar_ponto)
				}
			}
		},

		async saveConfig (item) {
			try {
				await axios.put(`${baseApiUrl}/ativos/${item.idativos}`, item)
				this.$toasted.success(`${this.formatConfigName(item.nome)} ${item.estado ? 'ativado' : 'desativado'}!`)
				await this.loadConfig()
			} catch (e) {
				showError(e)
			}
		},

		async toggleAcesso (item) {
			try {
				await axios.put(`${baseApiUrl}/usuarios/${item.idusuarios}`, {
					status: item.status ? 1 : 0
				})
				this.$toasted.success(`Acesso de ${item.nome.toUpperCase()} ${item.status ? 'liberado' : 'bloqueado'}!`)
			} catch (e) {
				showError(e)
			}
		},

		async toggleReconhecimentoFacial (item) {
			try {
				await axios.put(`${baseApiUrl}/usuarios/${item.idusuarios}`, {
					reconhecimento_facial: item.reconhecimento_facial ? 1 : 0
				})
				this.$toasted.success(`Reconhecimento facial ${item.reconhecimento_facial ? 'ativado' : 'desativado'}!`)
			} catch (e) {
				showError(e)
			}
		},

		async toggleAcessoDesktop (item) {
			try {
				await axios.put(`${baseApiUrl}/usuarios/${item.idusuarios}`, {
					acesso_desktop: item.acesso_desktop ? 1 : 0
				})
				this.$toasted.success(`Acesso externo ${item.acesso_desktop ? 'ativado' : 'desativado'}!`)
			} catch (e) {
				showError(e)
			}
		},

		async updatePermissao (item, permissao) {
			try {
				await axios.put(`${baseApiUrl}/usuarios/${item.idusuarios}`, {
					[`perm_${permissao}`]: item.permissoes[permissao] ? 1 : 0
				})
				this.$toasted.success(`Permissão ${permissao} ${item.permissoes[permissao] ? 'concedida' : 'removida'}!`)
			} catch (e) {
				showError(e)
			}
		},

		async updatePermissaoExtra (item, campoBanco, valorBool) {
			try {
				await axios.put(`${baseApiUrl}/usuarios/${item.idusuarios}`, {
					[campoBanco]: valorBool ? 1 : 0
				})
				this.$toasted.success(`Permissão ${campoBanco} ${valorBool ? 'concedida' : 'removida'}!`)
			} catch (e) {
				showError(e)
			}
		},

		formatConfigName (nome) {
			const names = {
				reconhecimento_facial: 'Reconhecimento Facial',
				acesso_externo: 'Acesso Externo Desktop'
			}
			if (names[nome]) return names[nome]
				return String(nome)
			.replace(/_/g, ' ')
			.replace(/\b\w/g, c => c.toUpperCase())
		}
	},

	async mounted () {
		await this.loadConfig()
		await this.loadFuncionarios()
	}
}
</script>


<style scoped>
.card-soft {
	border-radius: 12px;
}

.config-item {
	border-radius: 12px;
}

.search-input {
	max-width: 280px;
}

.compact-table >>> th {
	font-size: 11px !important;
	font-weight: 700 !important;
	padding: 0 10px !important;
}

.compact-table >>> td {
	padding: 0 10px !important;
	vertical-align: middle;
}

.perm-check >>> .v-input--selection-controls__input {
	margin: 0;
}
</style>
